export default __webpack_public_path__ + "static/media/logo1_large.508575ac.svg";